import axios from '../../plugins/axios';

export default {
    namespaced: true,

    state: {
        user: {
            firstname: '',
            lastname: '',
            avatar: '',
            birthday: '',
            city: '',
            site: '',
            images: [],
            instagram: '',
            phone: '',
            reviews: '',
            about: '',
        }, 
        auth: {}
    },

    mutations: {
        SET_USER(state, payload) {
            state.user = {
                ...state.user,
                ...payload
            };
            if(payload.token) {
                localStorage.setItem('marketoria-admin-token', payload.token);
            }
        },
        CLEAR_USER(state) {
            state.user = {
                phone: '',
                firstname: '',
                lastname: '',
                admin: false,
                partner: false,
            };
            localStorage.removeItem('marketoria-admin-token');
        },
        SET_VALUE(state, { prop, value }) {
            state.user[prop] = value;
        },
        SET_AUTH(state, payload) {
            state.auth = payload;
        },
    },

    actions: {
        async fetch({ commit }) {
            const { data } = await axios.get('/common/auth/profile');
            if(data.admin || data.partner) {
                commit('SET_USER', data);
            } else {
                commit('CLEAR_USER');
            }
            return data;
        },
        async save({ commit, state }) {
            let response = {};
            if(state.user.id) {
                response = await axios.put('/common/auth/profile', state.user);
            }
        },
        async login({ commit }, { phone }) {
            const { data } = await axios.post('/common/auth/login', { phone: phone.replace(/ /g, '') });
            commit('SET_AUTH', data);
            return data;
        },
        async confirm({ state, commit }, { code }) {
            const { data } = await axios.post('/common/auth/confirm', { ...state.auth, ...{ code } });
            commit('SET_USER', {
                ...state.user, 
                ...data
            });
            return data;
        },
        async logout({ commit }) {
            commit('CLEAR_USER');
        }
    },

    getters: {}
}